module.exports = __webpack_public_path__ + "static/media/card-DIS.2ad47edc.svg";